import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Alert,
  Box,
  FormHelperText,
  Grid,
  InputBase,
  InputLabel,
  Snackbar,
  Stack,
  Typography,
  styled,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { LoadingButton } from '@mui/lab';
import { loadCaptchaEnginge, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { openLogin } from '../../../../redux/slices/authUiSlice';
import useLocales from '../../../../hooks/useLocales';
import useAuth from '../../../../hooks/useAuth';

import palette from '../../../../theme/palette';
import { validatePhoneNumber } from '../../../../utils/validatePhoneNumber';
import { TelegramRegister } from './TelegramRegister';
import useCountdown from '../../../../hooks/useCountdown';
import uuidv4 from '../../../../utils/uuidv4';
import conObj from '../../../../utils/connection-assistant';
import MyDialog from '../../../../components/dialog-component/my-dialog';
import { telegramId } from '../../../../config';
import Logo from '../../../../assets/brand-logo.png';
import Image from '../../../../components/Image';

const StyledLabel = styled(InputLabel)(({ theme }) => ({
  opacity: 0.9,
  fontSize: '15px',
  color: '#fff',
  fontWeight: 300,
}));

const InputContainer = styled(Stack)(({ theme }) => ({
  opacity: 0.9,
  alignItems: 'center',
  borderRadius: '5px',
  height: '44px',
  padding: '0 5px',
  backgroundColor: '#fff',
}));

const StyledInput = styled(InputBase)(({ theme }) => ({
  opacity: 0.9,
  fontWeight: 400,
  fontFamily: 'sans-serif',
  flexGrow: 1,
  backgroundColor: '#d3d3d3',
  color: '#000',
  borderRadius: '10px',
  padding: '8.5px 13px',
  input: {
    '&::placeholder': {
      opacity: 0.9,
      color: palette.visitor.input.placeholder,
    },
  },
}));

const ErrorText = styled(Typography)(({ theme }) => ({
  opacity: 0.9,
  fontSize: '.75rem',
  color: palette.visitor.errorText,
}));

const FooterText = styled(Typography)(({ theme }) => ({
  opacity: 0.9,
  fontSize: '15px',
  fontFamily: 'sans-serif',
  fontWeight: 500,
  color: '#fff',
  cursor: 'pointer',
  marginTop: '20px',
}));

const LabelText = styled(Typography)(({ theme }) => ({
  opacity: 0.9,
  fontSize: '1.2rem',
  color: palette.visitor.dialog.title,
  fontWeight: 600,
}));

const BirthdayText = styled(Typography)(({ theme }) => ({
  opacity: 0.9,
  fontSize: '.75rem',
  color: palette.visitor.dialog.otherText,
  fontWeight: 500,
}));

const SubmitButton = styled(LoadingButton)(({ theme }) => ({
  width: '100%',
  marginBottom: 8,
  border: '1px solid #ffce30',
  backgroundColor: '#d4af37',
  color: '#fff',
  fontWeight: 500,
  '&:disabled': {
    filter: 'grayscale(1)',
  },
}));

const LinkText = ({ children }) => <span style={{ opacity: 0.9, marginTop: '8px', color: '#d4af37' }}>{children}</span>;

const _registerForm = {
  // userUserName: '',
  userPassword: '',
  userPhoneNumber: '',
  userFullName: '',
  // userEmail: '',
  // userBirthday: null,
  userReferralCode: '',
  otpCode: '',
  captcha: '',
};

const Register = ({ handleOpen, handleClose }) => {
  const { register } = useAuth();

  const dispatchUi = useDispatch();

  const [loginForm, setLoginForm] = useState(false);

  const { login } = useAuth();

  const [authData, setAuthData] = useState(null);

  const navigate = useNavigate();

  const { translate } = useLocales();

  const { enqueueSnackbar } = useSnackbar();

  const [registerForm, setRegisterForm] = useState(_registerForm);

  const [formError, setFormError] = useState({});

  const [otpUuid, setOtpUuid] = useState(null);

  const [resendExpiry, setResendExpiry] = useState(null);

  const resendCountdown = useCountdown(resendExpiry);

  const [verification, setVerification] = useState({
    number: null,
    id: null,
    otpSent: false,
    isVerified: false,
  });

  const [statusMessage, setStatusMessage] = useState({
    open: false,
    message: '',
  });

  const [validationErrors, setValidationErrors] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  // const verifyOtp = async () => {
  //   try {
  //     if (verification?.id) {
  //       await firebaseUtil.handleVerifyOTP(verification?.id, verification?.otp);
  //       setVerification((prev) => ({ ...prev, isVerified: true }));
  //     }
  //   } catch (error) {
  //     throw new Error(getOtpErrorMessage(translate, error));
  //   }
  // };

  const platformText = useMemo(
    () => authData?.platform.charAt(0).toUpperCase() + authData?.platform.slice(1),
    [authData]
  );

  const isNotValidSubmit = useMemo(() => {
    if (authData) {
      return (
        // !tncConfirmed ||
        // !registerForm?.userUserName ||
        !registerForm?.captcha ||
        // !registerForm?.userEmail ||
        !registerForm.userFullName ||
        !registerForm?.userPhoneNumber
        // (otpUuid && !registerForm?.otpCode)
      );
    }

    return (
      // !tncConfirmed ||
      // !registerForm?.userUserName ||
      !registerForm?.captcha ||
      // !registerForm?.userEmail ||
      !registerForm.userFullName ||
      !registerForm?.userPassword ||
      !registerForm?.userPhoneNumber
      // (otpUuid && !registerForm?.otpCode)
    );
  }, [registerForm, authData]);

  // useEffect(() => {
  //   const _referralCode = localStorage.getItem('referralCode');

  //   if (_referralCode) {
  //     setRegisterForm((prevState) => ({ ...prevState, userReferralCode: _referralCode }));
  //     localStorage.removeItem('referralCode');
  //   }

  //   setTimeout(() => {
  //     loadCaptchaEnginge(4, '#dd0000', '#fff', 'numbers');
  //   }, 1000);
  // }, []);

  // Load referral code (runs once)
  useEffect(() => {
    const _referralCode = localStorage.getItem('referralCode');

    if (_referralCode) {
      setRegisterForm((prev) => ({ ...prev, userReferralCode: _referralCode }));
      localStorage.removeItem('referralCode');
    }
  }, []);

  // Load captcha ONLY when dialog is open
  useEffect(() => {
    if (!handleOpen) return;

    const timer = setTimeout(() => {
      loadCaptchaEnginge(4, '#f0f2f5', '#454545', 'numbers');
    }, 100);

    return () => clearTimeout(timer);
  }, [handleOpen]);

  const handleFormChange = (event) => {
    const { name, value } = event.target;
    setRegisterForm((prevState) => ({ ...prevState, [name]: value }));
  };

  const onRequestOtp = async () => {
    try {
      setResendExpiry(null);
      let fingerprint = localStorage.getItem('fingerprint');
      if (!fingerprint) {
        fingerprint = uuidv4();
        localStorage.setItem('fingerprint', fingerprint);
      }

      const response = await conObj.post('otp_request.json', {
        no_hp: registerForm.userPhoneNumber.replace(/[^0-9]/g, ''),
        fingerprint,
        purpose: 'register',
      });

      // this is the error if logging in in  gold city

      setOtpUuid(response.data?.data?.data?.otp_uuid);
      setResendExpiry(moment().add(1, 'minute').toISOString());
    } catch (err) {
      console.log(`Error: ${err.message}`);
      const snackbarOptions = { variant: 'error', autoHideDuration: 5000 };
      enqueueSnackbar(err.message, snackbarOptions);
    }
  };

  const resendOtp = async () => {
    setIsLoading(true);
    await onRequestOtp();
    setIsLoading(false);
  };

  const onSubmit = async (event) => {
    event?.preventDefault();

    if (!isValid()) return;
    setIsLoading(true);
    try {
      // if (!otpUuid && !registerForm?.otpCode) {
      //   await onRequestOtp();
      // } else {
      // if (!registerForm?.otpCode) {
      //   throw new Error(translate('x_is_required', { x: 'OTP' }));
      // }

      const requestData = {
        'user-username': registerForm?.userPhoneNumber.replace(/[^0-9]/g, ''),
        'user-password': registerForm?.userPassword.trim(),
        'user_profile-no_hp': registerForm?.userPhoneNumber,
        'user-full_name': registerForm?.userFullName,
        'user-otp_code': registerForm?.otpCode,
        // 'user-email': registerForm?.userEmail,
        // 'user_profile-birthday': moment(registerForm?.userBirthday).format('YYYY-MM-DD'),
        'user-referral_code': registerForm?.userReferralCode,
        'transaction-promotion_id': localStorage.getItem('promotion_id') || '',
      };

      const guestClaimedPromo = localStorage.getItem('promotion_id');

      if (guestClaimedPromo) {
        requestData['transaction-promotion_id'] = guestClaimedPromo;
      }

      if (authData) {
        const _authData = JSON.parse(JSON.stringify(authData));
        delete _authData?.platform;
        requestData['user_third_party_login-platform'] = authData?.platform;

        requestData['user_third_party_login-data'] = JSON.stringify(_authData);
      }

      await register(requestData);
      const _referralCode = localStorage.getItem('referralCode');
      if (_referralCode) localStorage.removeItem('referralCode');
      localStorage.removeItem('promotion_id');

      window.parent.location = '?isnew';
      // }
    } catch (err) {
      console.log(`Error: ${err.message}`);
      const snackbarOptions = { variant: 'error', autoHideDuration: 5000 };
      enqueueSnackbar(err.message, snackbarOptions);
      const errorSplit = err.message?.split(',');
      if (errorSplit?.length > 1) {
        setValidationErrors(errorSplit);
      } else setValidationErrors([err.message]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // console.log('Enter key handler');
    const keyDownHandler = (event) => {
      if (event.key === 'Enter') {
        event?.preventDefault();
        onSubmit();
      }
    };

    document.addEventListener('keydown', keyDownHandler);

    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [registerForm]);

  useEffect(() => {
    if (authData) {
      setRegisterForm((prev) => ({
        ...prev,
        userFullName: `${authData?.first_name || ''} ${authData?.last_name || ''}`,
        userEmail: `${authData?.email || ''}`,
      }));
    }
  }, [authData]);

  const handleTelegramLogin = () => {
    window?.Telegram?.Login.auth({ bot_id: telegramId, request_access: true }, (data) => {
      if (!data) return;
      thirdPartyAuth(data);
    });
  };

  const thirdPartyAuth = async (response, type = 'telegram') => {
    try {
      const apiResponse = await conObj.post('users/tpp_login.json', {
        'user_third_party_login-data': JSON.stringify(response),
        'user_third_party_login-platform': type,
      });

      const responseData = apiResponse?.data?.data;

      if (responseData?.registerNow) {
        setAuthData({ ...response, platform: type });
        return;
      }

      if (responseData?.token) {
        await login(
          {},
          {
            token: responseData.token,
            firstName: responseData.first_name,
            username: responseData.username,
            fullName: responseData.full_name,
            lastName: responseData.last_name,
            email: responseData.email,
          }
        );
        return;
      }

      throw new Error(`Login to ${type} failed`);
    } catch (error) {
      enqueueSnackbar(error?.message, { variant: 'error' });
    }
  };

  // const isValid = () => {
  //   let valid = true;
  //   const _error = {};

  //   if (!registerForm?.userPhoneNumber?.trim()) {
  //     valid = false;
  //     _error.userPhoneNumber = translate('invalid_x', { x: translate('phone_number') });
  //   } else if (registerForm?.userPhoneNumber?.trim()?.length !== 9) {
  //     valid = false;
  //     _error.userPhoneNumber = translate('minimum_length_is_x', { x: 9 });
  //     _error.userPhoneNumber += ', ';
  //     _error.userPhoneNumber += translate('maximum_length_is_x', { x: 9 });
  //   } else if (!/^[35789]/.test(registerForm?.userPhoneNumber?.trim())) {
  //     valid = false;
  //     _error.userPhoneNumber = translate('username_must_start_with', { x: '3, 5, 7, 8, or 9' });
  //   }
  //   // else if (registerForm?.userPhoneNumber?.trim()) {
  //   //   const invalidPhoneNumber = validatePhoneNumber(registerForm?.userPhoneNumber?.trim(), translate);

  //   //   if (invalidPhoneNumber) {
  //   //     valid = false;
  //   //     _error.userPhoneNumber = invalidPhoneNumber;
  //   //   }
  //   // }
  //   else {
  //     _error.userPhoneNumber = '';
  //   }

  //   if (
  //     registerForm?.userPassword?.trim()?.length < 6 ||
  //     (registerForm?.userPassword?.trim()?.length > 20 && !authData)
  //   ) {
  //     valid = false;
  //     _error.userPassword = translate('password_must_be_6_to_20');
  //   } else {
  //     _error.userPassword = '';
  //   }

  //   // password
  //   // if (registerForm?.userPassword.trim() < 5 && !authData) {
  //   //   valid = false;
  //   //   _error.userPassword = translate('invalid_x_must_be_atleast_y_characters', { x: translate('password'), y: '5' });
  //   // } else {
  //   //   _error.userPassword = '';
  //   // }

  //   // // fullname
  //   // if (!registerForm?.userFullName.trim()) {
  //   //   valid = false;
  //   //   _error.userFullName = translate('invalid_x_must_be_atleast_y_characters', { x: translate('full_name'), y: '1' });
  //   // } else {
  //   //   _error.userFullName = '';
  //   // }

  //   // email
  //   // if (!registerForm?.userEmail.match('[a-z0-9]+@[a-z]+.[a-z]{2,3}')) {
  //   //   valid = false;
  //   //   _error.userEmail = translate('invalid_x', { x: translate('email') });
  //   // } else {
  //   //   _error.userEmail = '';
  //   // }

  //   // phone number
  //   // if (!registerForm?.userPhoneNumber.trim()) {
  //   //   valid = false;
  //   //   _error.userPhoneNumber = translate('x_is_required', { x: translate('phone_number') });
  //   // } else if (registerForm?.userPhoneNumber.trim().length < process.env.REACT_APP_MOBILENUMBER_MIN_LENGTH) {
  //   //   valid = false;
  //   //   _error.userPhoneNumber = translate(`invalid_x_must_be_atleast_y_characters`, {
  //   //     x: translate('phone_number'),
  //   //     y: process.env.REACT_APP_MOBILENUMBER_MIN_LENGTH,
  //   //   });
  //   // } else if (registerForm?.userPhoneNumber.trim().length > process.env.REACT_APP_MOBILENUMBER_MAX_LENGTH) {
  //   //   valid = false;
  //   //   _error.userPhoneNumber = translate('phone_num_x_max', { x: process.env.REACT_APP_MOBILENUMBER_MAX_LENGTH });
  //   // } else {
  //   //   _error.userPhoneNumber = '';
  //   // }

  //   // birthday
  //   // if (!registerForm?.userBirthday) {
  //   //   valid = false;
  //   //   _error.userBirthday = translate('x_is_required', { x: translate('birthday') });
  //   // } else {
  //   //   _error.userBirthday = '';
  //   // }

  //   if (validateCaptcha(registerForm?.captcha?.trim(), false) === true) {
  //     _error.userCaptcha = '';
  //   } else {
  //     valid = false;
  //     _error.userCaptcha = translate('captcha_not_match');
  //   }

  //   setFormError((prevState) => _error);

  //   return valid;
  // };

  const isValid = () => {
    let valid = true;
    const _error = {};

    const phone = registerForm?.userPhoneNumber?.trim();
    const password = registerForm?.userPassword?.trim();
    const captcha = registerForm?.captcha?.trim();

    // --------- Phone number validation ----------
    if (!phone) {
      valid = false;
      _error.userPhoneNumber = translate('invalid_x', { x: translate('phone_number') });
    } else if (!/^[35789]\d{8}$/.test(phone)) {
      valid = false;
      _error.userPhoneNumber = translate('phone_number_must_start_with', { x: '3, 5, 7, 8, or 9' });
    } else {
      _error.userPhoneNumber = '';
    }

    // --------- Password validation ----------
    if (!password || password.length < 6 || password.length > 20) {
      valid = false;
      _error.userPassword = translate('password_must_be_6_to_20');
    } else {
      _error.userPassword = '';
    }

    // --------- Captcha validation ----------
    if (validateCaptcha(captcha, false) === true) {
      _error.userCaptcha = '';
    } else {
      valid = false;
      _error.userCaptcha = translate('captcha_not_match');
    }

    setFormError(_error);
    return valid;
  };

  return (
    <>
      <MyDialog open={handleOpen} close={handleClose} maxSize="md">
        <form onSubmit={onSubmit}>
          <Box sx={{ maxWidth: '900px', margin: 'auto' }}>
            {validationErrors && (
              <Alert
                onClose={() => setValidationErrors(null)}
                severity="error"
                sx={{ opacity: 0.9, width: '100%', my: '10px' }}
              >
                {
                  <ul style={{ marginLeft: 10 }}>
                    {validationErrors?.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                }
              </Alert>
            )}
            {authData ? (
              <Alert sx={{ width: '100%', my: '10px' }}>
                {translate('linked_successfully_x', {
                  x: platformText,
                })}
              </Alert>
            ) : (
              ''
            )}

            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, mb: 3 }}>
              <Image sx={{ width: 180 }} src={Logo} />
            </Box>
            {/* {!otpUuid ? ( */}
            <Box display={'flex'} flexDirection={'column'} gap={1}>
              <Box display={'flex'} flexDirection={'column'} width={'100%'}>
                <StyledLabel>{translate('phone_number')}</StyledLabel>
                <StyledInput
                  fullWidth
                  type="number"
                  name="userPhoneNumber"
                  value={registerForm?.userPhoneNumber}
                  placeholder="e.g. 912345678"
                  onChange={(e) => handleFormChange(e)}
                />
                {formError?.userPhoneNumber && (
                  <span style={{ fontSize: '.75rem', color: 'red' }}>{formError?.userPhoneNumber}</span>
                )}
              </Box>
              <Box display={'flex'} flexDirection={'column'} width={'100%'}>
                <StyledLabel>{translate('full_name')}</StyledLabel>
                <StyledInput
                  fullWidth
                  name="userFullName"
                  value={registerForm?.userFullName}
                  onChange={(e) => handleFormChange(e)}
                  placeholder={translate('please_input_your_x', { x: translate('full_name') })}
                />
                {formError?.userFullName && <ErrorText>{formError?.userFullName}</ErrorText>}
              </Box>
              {!authData && (
                <>
                  <Box display={'flex'} flexDirection={'column'} width={'100%'}>
                    <StyledLabel>{translate('password')}</StyledLabel>
                    <StyledInput
                      fullWidth
                      type="password"
                      name="userPassword"
                      value={registerForm?.userPassword}
                      onChange={(e) => handleFormChange(e)}
                      placeholder={translate('password_placeholder')}
                    />
                  </Box>
                  {formError?.userPassword && <ErrorText>{formError.userPassword}</ErrorText>}
                </>
              )}
              <Box display={'flex'} flexDirection={'column'} width={'100%'}>
                <StyledLabel>{translate('friend_referral_code')}</StyledLabel>
                <StyledInput
                  fullWidth
                  name="userReferralCode"
                  value={registerForm?.userReferralCode}
                  onChange={(e) => handleFormChange(e)}
                  placeholder={translate('no_friend')}
                />
              </Box>

              <Box
                display={'flex'}
                width={'100%'}
                gap={1}
                mt={2}
                alignItems={'center'} // Vertically centers the two items
                sx={{
                  '& canvas': {
                    height: '45px !important',
                    width: '100px !important', // Slightly wider often looks better for 4 digits
                    borderRadius: '8px',
                    cursor: 'pointer',
                    border: '1px solid #ccc',
                    display: 'block', // Removes the bottom "ghost" padding baseline
                  },
                  // This targets the div that LoadCanvasTemplateNoReload creates
                  '& #react-captcha-load-canvas-no-reload': {
                    display: 'flex',
                    alignItems: 'center',
                    height: '45px',
                  },
                }}
              >
                <Box sx={{ height: '45px', display: 'flex', alignItems: 'center' }}>
                  {handleOpen && <LoadCanvasTemplateNoReload />}
                </Box>

                <StyledInput
                  fullWidth
                  name="captcha"
                  placeholder={translate('enter_text_on_the_left')}
                  value={registerForm?.captcha}
                  onChange={(e) => handleFormChange(e)}
                  sx={{
                    height: '45px',
                    '& .MuiInputBase-root': { height: '45px' }, // Forces MUI internal height if StyledInput is a wrapper
                  }}
                />

                {formError?.userCaptcha && <ErrorText>{formError?.userCaptcha}</ErrorText>}
              </Box>

              <Stack direction="column" alignItems={'center'} mt={2}>
                <SubmitButton
                  sx={{
                    mb: 2,
                    background: 'linear-gradient(to right, #c34029, #ff7214)',
                    color: '#fff',
                    fontWeight: 'bold',
                    fontSize: '16px',
                    borderRadius: '8px',
                  }}
                  variant="contained"
                  type="submit"
                  disabled={isNotValidSubmit}
                  loading={isLoading}
                >
                  <span style={{ opacity: isLoading ? 0 : 1 }}>{translate('register')}</span>
                </SubmitButton>

                <TelegramRegister />

                <FooterText sx={{ fontSize: { xs: '0.9rem', sm: '0.875rem', md: '1rem' } }}>
                  {translate('already_have_account')}
                </FooterText>
                <LinkText>
                  <Stack
                    sx={{ cursor: 'pointer' }}
                    onClick={() => {
                      dispatchUi(openLogin());
                    }}
                  >
                    {translate('login_here')} {'>'}
                  </Stack>
                </LinkText>
              </Stack>
            </Box>
            {/* ) : (
              <>
                <Box
                  sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: '0.6rem',
                  }}
                >
                  <LabelText>{translate('input_otp')}</LabelText>
                </Box>
                <LabelText sx={{ fontWeight: 500, fontSize: '12px' }}>{translate('otp_sent')}</LabelText>
                <Box sx={{ my: '0.6rem' }}>
                  <StyledInput
                    fullWidth
                    name="otpCode"
                    value={registerForm?.otpCode}
                    onChange={(e) => handleFormChange(e)}
                    placeholder={translate('verification_code')}
                  />
                </Box>

                <Box sx={{ display: 'flex', mb: 2 }}>
                  {resendCountdown?.seconds !== '00' ? (
                    <>
                      <FormHelperText>{translate('send_again_in_x', { x: resendCountdown.seconds })}</FormHelperText>
                    </>
                  ) : (
                    <>
                      <FormHelperText
                        sx={{ textDecoration: 'underline', fontWeight: 900, cursor: 'pointer' }}
                        onClick={!isLoading ? () => resendOtp() : null}
                      >
                        {translate('send_again')}
                      </FormHelperText>
                    </>
                  )}
                </Box>

                <SubmitButton
                  fullWidth
                  onClick={() => onSubmit()}
                  // onClick={() => verifyOtp()}
                  disabled={isNotValidSubmit}
                  loading={isLoading}
                  sx={{
                    mb: 2,
                    background: isNotValidSubmit ? '#dfd6d6!important' : 'linear-gradient(to right, #c34029, #ff7214)',
                    color: '#fff',
                    fontWeight: 'bold',
                    fontSize: '16px',
                    borderRadius: '8px',
                  }}
                >
                  {translate('sign_up')}
                </SubmitButton>
              </>
            )} */}
          </Box>

          {statusMessage?.open && (
            <Snackbar
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              open={statusMessage.open}
              autoHideDuration={3000}
              sx={{ width: 'fit-content' }}
              onClose={() => setStatusMessage((prevState) => ({ ...prevState, open: false }))}
            >
              <Alert
                onClose={() => setStatusMessage((prevState) => ({ ...prevState, open: false }))}
                severity={statusMessage.type}
                sx={{ width: '100%' }}
              >
                {statusMessage.message}
              </Alert>
            </Snackbar>
          )}
        </form>
      </MyDialog>
    </>
  );
};

Register.propTypes = {
  setActiveTab: PropTypes.func,
};

export default Register;
